import { JSX, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import InvoiceViewerRoute from "./InvoiceViewerRoute";
import { TEXTS } from "../constants/texts";
import ErrorMessage from "../components/ErrorMessage";
import { ERRORS } from "../constants/errorMessages";
import AhSso from "../auth/AhSso";
import { Skeleton } from "@mui/material";

interface ProtectedRoutesProps {
  isGroupMember: boolean | null;
  apiToken: string | null;
  accessApi: () => Promise<void>;
}

const ProtectedRoutes = ({ isGroupMember, apiToken, accessApi }: ProtectedRoutesProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      if (isGroupMember && !apiToken) {
        try {
          await accessApi();
        } catch (err) {
          setError(ERRORS.apiAuthError);
        }
      }

      if (isMounted) {
        setIsLoading(false);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [isGroupMember, apiToken, accessApi]);

  const renderElement = (element: JSX.Element) => {
    if (isLoading) {
      return <Skeleton />;
    }
  
    if (isGroupMember === null) {
      return <Skeleton />;
    }
  
    if (!isGroupMember) {
      return <p>{TEXTS.noAccess}</p>;
    }
  
    if (!apiToken) {
      return <Skeleton />;
    }
  
    return element;
  };

  if (error) {
    return <ErrorMessage message={error} />
  };

  return (
    <Routes>
      <Route path="/" element={<></>} />

      <Route path="/ahsso" element={<AhSso />} />
      <Route
        path="/visa_faktura/:id"
        element={renderElement(<InvoiceViewerRoute token={apiToken!} />)}
      />
      <Route
        path="/:regionNr/:period/:bokfTyp/:id"
        element={renderElement(<InvoiceViewerRoute token={apiToken!} />)}
      />
      <Route
        path="/bilaga/:regionNr/:period/:bokfTyp/:id/:bilagaNr"
        element={renderElement(<InvoiceViewerRoute token={apiToken!} />)}
      />
    </Routes>
  );
};

export default ProtectedRoutes;
